// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2HnM0","icon":"SortAdornment_icon__1aXLX","up":"SortAdornment_up__1bc2R","down":"SortAdornment_down__qJn0i","active":"SortAdornment_active__2I7SE"};